import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material/menu';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthorizeService } from 'src/app/_core/access-control/authorize.service';
import { UserState } from 'src/app/_shared/state/user.state';
import { AgentService } from 'src/app/agent/service/agent.service';
import { AgentState } from 'src/app/agent/state/agent.state';
import { AppState } from 'src/app/app.state';

@Component({
  selector: 'app-search-agent',
  templateUrl: './search-agent.component.html',
  styleUrls: ['./search-agent.component.scss'],
})
export class SearchAgentComponent implements OnInit {
  @ViewChild('viewAgentDropDown', { static: true }) menu: MatMenuTrigger;
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  agentFilterForm: FormGroup;
  viewPosition: string;
  touched: boolean = false;
  location: any;
  userDetails: any;
  isFindAnAgent: any;
  onDestroyNotifier$ = new Subject();
  portFolioUrl: any;
  baseUrl: any;
  contactAgentInfo: any;
  companyInfo: any = {};
  showAgentContact: Boolean = false;
  userType: any;

  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public authorizeService: AuthorizeService,
    public appState: AppState,
    public userState: UserState,
    public agentService: AgentService,
    public agentState: AgentState
  ) { }

  ngOnInit(): void {
    combineLatest([this.userState.userDetail$, this.appState.companyInfo$])
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(([userDetails, companyInfo]) => {
        if (userDetails) {
          this.userDetails = userDetails;
        }

        if (companyInfo && Object.keys(companyInfo).length) {
          this.companyInfo = companyInfo;

          if (!this.appState.authTokenValue?.idToken && companyInfo.source == 'agentSignUp') {
            this.showAgentContact = true;
          } else if (this.userDetails?.userType == 'investor' && companyInfo.source == 'agentSignUp') {
            this.showAgentContact = true;
          } else if (!this.appState.authTokenValue?.idToken && companyInfo.source == 'loSignUp') {
            this.showAgentContact = false;
          } else if (this.userDetails?.userType == 'investor' && companyInfo.source == 'loSignUp') {
            this.showAgentContact = false;
          } else if (
            (companyInfo.source == 'loSignUp' || companyInfo.source == 'agentSignUp') &&
            (this.userDetails?.userType == 'agent' || this.userDetails?.userType == 'loanOfficer')
          ) {
            this.showAgentContact = false;
          } else {
            this.showAgentContact = true;
          }
        }
      });
    this.baseUrl = this.appState.companyInfoValue.baseUrl;
    this.portFolioUrl = `https://${this.baseUrl}/portfolio/`;
    this.agentState.agentList$.pipe().subscribe((res: any) => {
      const agents = res?.data;
      if (agents?.length) {
        this.contactAgentInfo = agents[0];
        this.isFindAnAgent = agents.length > 1;
      }
    });

    this.agentFilterForm = this.formBuilder.group({
      searchAddress: [''],
      searchName: [''],
    });
    this.agentFilterForm.controls.searchAddress.valueChanges.subscribe(() => {
      this.touched = true;
    });
    let params = { limit: 5, offset: 0 };
    this.getAgentList(params);
  }
  get searchAddressCtrl(): FormControl {
    return this.agentFilterForm.controls.searchAddress as FormControl;
  }

  getAddressComponents(property?) {
    this.location = property;
    let autoSearchAddress = `${property.City ? property.City + ', ' : ''}${property.State ? property.State + ' ' : ''}${property.PostalCode ? property.PostalCode : ''
      }`.trim();
    this.agentFilterForm.patchValue({
      searchAddress: autoSearchAddress,
    });
    this.touched = false;
  }

  submit() {
    if (!this.agentFilterForm.value.searchAddress) this.location = null;
    if (this.touched && this.agentFilterForm.value.searchAddress) {
      this.location = null;
      this.searchAddressCtrl.setErrors({ message: true });
      return;
    } else {
      const queryParam = {
        name: this.agentFilterForm.value.searchName || null,
        city: this.location?.City || null,
        state: this.location?.State || null,
        zip: this.location?.PostalCode || null,
      };
      this.router.navigate(['/agent'], {
        relativeTo: this.activatedRoute,
        queryParams: queryParam,
        queryParamsHandling: 'merge',
      });
    }
  }

  close() {
    this.trigger.closeMenu();
  }

  contactAgent() {
    window.open(this.portFolioUrl + this.contactAgentInfo.shortId, '_blank');
  }

  getAgentList(params) {
    if (this.userDetails) {
      params['userId'] = this.userDetails?.id;
      params['userRoles'] = this.userDetails?.roles;
    }
    this.agentService
      .getAgentList(params)
      .pipe()
      .subscribe((res: any) => { });
  }
}
